/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Workout_TempoInputs */

const en_coach_workout_tempo = /** @type {(inputs: Coach_Workout_TempoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`45min Tempo`)
};

const de_coach_workout_tempo = /** @type {(inputs: Coach_Workout_TempoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`45min Tempo`)
};

/**
* | output |
* | --- |
* | "45min Tempo" |
*
* @param {Coach_Workout_TempoInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_workout_tempo = /** @type {((inputs?: Coach_Workout_TempoInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Workout_TempoInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_workout_tempo(inputs)
	return de_coach_workout_tempo(inputs)
});